import React, { Component } from 'react'
import { Permissions } from 'permissions'
import { Tenant } from 'models/Blip/Index'
import { GridView } from 'models/GridView'
import { TenantService } from 'connection/TenantService'
import { PermissionService } from 'services/PermissionService'
import { ModalFactory, MODAL_TYPES } from 'components/ModalFactory'
import { OrganizationMembers } from './members/Index'
import { OrganizationApplications } from './applications/Index'
import { Input, Icon, Card, List, Button, Tabs, Statistic } from 'antd'
import { SearchOrganizationResponse, BillingPlansResponse } from 'models/response/Index'
import { OrganizationRequest, SearchOrganizationRequest, TransactionRequest, SubscriptionRequest, BaseRequest, AiAgentsPlanRequest, SetAiAgentsPlanRequest } from 'models/request/Index'
import { searchOrganization, getPlans, setSubscription, processTransaction, setTenantOwnerIdentity, getAiAgentsPlan, getAllAiAgentsPlans, setAiAgentsPlan } from 'services/CeberusApiService'
import { PushNotification } from 'utils/PushNotification'
import { OrganizationMTLS } from './mTLS/Index'
import { AiAgentStudioComponent } from './aiAgentStudio/Index'

const TabPane = Tabs.TabPane
const ListItem = List.Item
const ListItemMeta = List.Item.Meta
const { Search } = Input

const NO_DATA = 'no data';
const AI_AGENT_PLAN_NOT_DEFINED = 'Not defined';
const AI_AGENT_PLAN_UPDATED_SUCCESS_MESSAGE = 'AI Agent plan was successfully updated.';
const AI_AGENTS_TAB_KEY = '5';

export class OrganizationSearch extends Component {
  state = {
    isLoading: false,
    isLoadingButtonSearch: false,
    isModalLoading: false,
    isModalVisible: false,
    currentModal: '',
    editingRecord: {},
    tenantSelected: new Tenant(),
    gridView: new Array<GridView>(),
    plans: new Array<BillingPlansResponse>(),
    organizationResponse: new SearchOrganizationResponse(),
    aiAgentsPlanName: NO_DATA,
    canChangePlan: PermissionService.hasPermission(Permissions.Organization_Search__Edit),
    canCreateOrganization: PermissionService.hasPermission(Permissions.Organization_Create),
    activeTabKey: '1',
    allAiAgentsPlans: [],
    originalAiAgentsPlans: []
  }

  formRef: any;

  async componentDidMount() {
    await this.loadPage()
  }

  setComponentLoading = (isLoading: boolean) : void => {
    this.setState({ isLoading })
  }

  handleModalVisibility = (type: string, visibility: boolean) : void => {
    switch (type) {
      case MODAL_TYPES.EditAccountPlan:
      case MODAL_TYPES.PerformTransaction:
      case MODAL_TYPES.SetAiAgentsPlan:
      case MODAL_TYPES.EditTenantOwnerIdentity:
        this.setState({
          isModalVisible: visibility,
          currentModal: type,
        })
        if (!visibility) {
          this.setState({ editingRecord: {} })
        }
        break
      default:
        PushNotification.warnig('Unrecognized modal type');
    }
  }

  handleOnOpenModal = (record: any, type: string) : void => {
    this.setState({ editingRecord: record, currentModal: type })
    this.handleModalVisibility(type, true)
  }

  handleSaveTenantOwnerIdentity = () : void => {
    this.setState({ isModalLoading: true });

    const form = this.formRef.props.form;

    form.validateFields(async (errors, values) => {
      if (errors) {
        this.setState({ isModalLoading: false });
        throw errors;
      }

      try {
        const { tenantOwner } = values;

        var request = new OrganizationRequest();
        request.OrganizationId = this.state.organizationResponse.Id;
        request.UserIdentity = `${encodeURIComponent(tenantOwner)}@blip.ai`;

        var response = await setTenantOwnerIdentity(request);

        form.resetFields();

        this.setState({
          currentModal: '',
          editingRecord: {}
        });

        await this.loadPage();
        await this.onSearch(this.state.organizationResponse.Id);

        this.setState({ isModalLoading: false });

        PushNotification.success(response);
      } catch (error) {
        PushNotification.httpError(error);
      } finally {
        this.setState({ isModalLoading: false });
      }
    })
  }

  handleOnOkModal = (type: string) : void => {
    this.setState({ isModalLoading: true });

    const form = this.formRef.props.form;

    form.validateFields(async (err, values) => {
      if (err) {
        this.setState({ isModalLoading: false });
        return
      }

      try {
        switch (type) {
          case MODAL_TYPES.EditAccountPlan: {
            const { accountPlan } = values
            await this.handlePlanChange(accountPlan)
            break
          }
          case MODAL_TYPES.PerformTransaction: {
            const { operation, amount } = values
            await this.processTransaction(operation, amount);
            break
          }
          case MODAL_TYPES.EditTenantOwnerIdentity: {
            await this.handleSaveTenantOwnerIdentity();
            break
          }
          case MODAL_TYPES.SetAiAgentsPlan: {
            const { plan } = values
            await this.handleSetAiAgentsPlan(plan);
            break
          }
          default:
            PushNotification.warnig('Unrecognized modal type');
            break
        }

        form.resetFields();
        this.setState({ isModalVisible: false, editingRecord: {}, });
      } catch (e) {
        PushNotification.error('Ops! We had a problem! See on the console.');
        throw e
      } finally {
        await this.onSearch(this.state.organizationResponse.Id);
        this.setState({ isModalLoading: false });
      }
    })
  }

  handleTabChange = (key: string) => {
    this.setState({ activeTabKey: key }, async () => {
      if (key === AI_AGENTS_TAB_KEY) {
        this.setComponentLoading(true);
        try {
          await this.loadAiAgentsPlan();
        } catch (error) {
          PushNotification.httpError(error);
        } finally {
          this.setComponentLoading(false);
        }
      }
    });
  };

  saveFormRef = (formRef: any) : void => {
    this.formRef = formRef
  }

  loadPage = async () : Promise<void>  => {
    const tenantSelected = TenantService.getSelectedTenant();
    this.setState({ tenantSelected });
    const request = new SearchOrganizationRequest();
    request.ClusterName = tenantSelected && tenantSelected.name ? tenantSelected.name : '';
    const plans = await getPlans(request);
    this.setState({ plans });
  }

  onSearch = async (identifier: string) : Promise<void> => {
    try {
      this.setState({ organizationResponse: undefined , isLoading: true, isLoadingButtonSearch: true });

      if(identifier){
        const tenantSelected = TenantService.getSelectedTenant();
        const request = new SearchOrganizationRequest();
        request.ClusterName = tenantSelected.name;
        request.OrganizationId = identifier;
        const organizationResponse = await searchOrganization(request);
        this.setState({ tenantSelected });
        this.setState({ organizationResponse }, () => {
          this.handleTabChange(this.state.activeTabKey);
        });
      }
    } catch (error) {
      this.setState({ organizationResponse: undefined })
      PushNotification.httpError(error);
    } finally {
      this.setState({ isLoading: false, isLoadingButtonSearch: false });
    }
  }

  loadAiAgentsPlan = async (): Promise<void> => {
    try {
      const aiAgentsPlanName = await this.getAiAgentsPlanName();
      this.setState({ aiAgentsPlanName });
    } catch (error) {
      PushNotification.httpError(error);
    }
  }

  handlePlanChange = async (accountPlan: string) : Promise<void> => {
    this.setComponentLoading(true);
    try {
      const { organizationResponse } = this.state;
      const request = new SubscriptionRequest();
      request.ClusterName = this.state.tenantSelected.name;
      request.OrganizationId =  organizationResponse.PaymentAccount;
      request.PlanId = accountPlan;
      const response = await setSubscription(request);
      await this.onSearch(organizationResponse.PaymentAccount);
      PushNotification.success(response);
    } catch (error) {
      PushNotification.httpError(error);
    } finally {
      this.setComponentLoading(false);
    }
  }

  handleSetAiAgentsPlan = async (plan: string) : Promise<void> => {
    this.setComponentLoading(true);
    try {
      const { organizationResponse } = this.state
      const request = new SetAiAgentsPlanRequest();
      request.ClusterName = this.state.tenantSelected.name;
      request.OrganizationId =  organizationResponse.Id;
      request.Plan = plan;

      await setAiAgentsPlan(request);
      this.handleTabChange(AI_AGENTS_TAB_KEY);

      PushNotification.success(AI_AGENT_PLAN_UPDATED_SUCCESS_MESSAGE);
    } catch (error) {
      PushNotification.httpError(error);
    } finally {
      this.setComponentLoading(false);
    }
  }

  processTransaction = async (type: string, value: number) : Promise<void> => {
    try {
      const { organizationResponse } = this.state
      this.setComponentLoading(true);
      const request = new TransactionRequest();
      request.ClusterName = this.state.tenantSelected.name;
      request.OrganizationId =  organizationResponse.PaymentAccount;
      request.Type =  type;
      request.Amount = value;
      const response = await processTransaction(request);
      PushNotification.success(response);
    }
    catch (error) {
      PushNotification.httpError(error);
    } finally {
      this.setComponentLoading(false);
    }
  }

  getPlanName = (planId: string) : string => {
    if(this.state.plans.length > 0){
      return this.state.plans.find(plan => {
        return plan.id == planId
      }).name
    }
    return NO_DATA;
  }

  getCurrentPlanName = () : string => {
    const { organizationResponse, plans } = this.state;
    if(plans.length > 0 && organizationResponse.PlanId){
      return this.getPlanName(organizationResponse.PlanId);
    }
    return NO_DATA
  }

  getAiAgentsPlanName = async (): Promise<string> => {
    try {
      const request = new AiAgentsPlanRequest();
      request.ClusterName = this.state.tenantSelected.name;
      request.OrganizationId = this.state.organizationResponse.Id;

      const response = await getAiAgentsPlan(request);
      return response && response.Plan;
    } catch (error) {
      if (error.response.status === 404) {
        return AI_AGENT_PLAN_NOT_DEFINED;
      }
      PushNotification.httpError(error);
      return NO_DATA;
    }
  }

  getAllAiAgentsPlans = async () => {
    if (this.state.originalAiAgentsPlans.length === 0) {
      try {
        const request = new BaseRequest();
        request.ClusterName = this.state.tenantSelected.name;

        const response = await getAllAiAgentsPlans(request);

        this.setState({ originalAiAgentsPlans: response.Plans }, this.updateAvailableAiAgentsPlans);
      } catch (error) {
        PushNotification.httpError(error);
        this.setState({ originalAiAgentsPlans: [], allAiAgentsPlans: [] });
      }
    } else {
      this.updateAvailableAiAgentsPlans();
    }
  }

  updateAvailableAiAgentsPlans = () => {
    const { originalAiAgentsPlans, aiAgentsPlanName } = this.state;
    const availablePlans = originalAiAgentsPlans.filter(plan => plan !== aiAgentsPlanName);
    this.setState({ allAiAgentsPlans: availablePlans });
  }

  hasOrganization = () : boolean => {
    const { organizationResponse } = this.state
    return (organizationResponse && organizationResponse.Id) ? true : false;
  }

  getItemList = () : Array<GridView> => {
    const { organizationResponse } = this.state

    if (this.hasOrganization()) {
      return [
        {
          title: 'Id:',
          description: organizationResponse.Id,
        },
        {
          title: 'Name:',
          description: organizationResponse.Name,
        },
        {
          title: 'Cluster:',
          description: organizationResponse.ClusterName,
        },
        {
          title: 'Hubspot Company ID:',
          description: organizationResponse.HubspotCompanyId,
        },
        {
          title: 'Deal ID:',
          description: organizationResponse.DealId,
        },
        {
          title: 'Test Contract:',
          description: organizationResponse.IsTestContract,
        },
        {
          title: 'Creation Date:',
          description: organizationResponse.CreatedAt,
        },
        {
          title: 'Payment Account:',
          description: organizationResponse.PaymentAccount,
        },
        {
          title: 'Blip Subsidiary:',
          description: organizationResponse.BlipSubsidiary,
        },
        {
          title: 'Owner:',
          description: [
            organizationResponse.Owner,
            <Button
              key="editTenantOwnerIdentityButton"
              type="primary"
              shape="round"
              size="small"
              icon="edit"
              className="ml4"
              disabled={!this.state.canCreateOrganization}
              onClick={() => this.handleOnOpenModal({ TenantSelect: this.state.tenantSelected }, MODAL_TYPES.EditTenantOwnerIdentity)}
            >
              Change Owner
            </Button>
          ]
        },
        {
          title: 'URL Blip:',
          description: [organizationResponse.BlipUrl,
            <Button
              key="openBlipButton"
              type="primary"
              shape="round"
              size="small"
              icon="search"
              className="ml4"
              onClick={()=>{ window.open(organizationResponse.BlipUrl, '_blank') }}
            >
              Open Blip
            </Button>
          ],
        },
        {
          title: 'URL Desk:',
          description: [organizationResponse.DeskUrl,
            <Button
              key="openDeskButton"
              type="primary"
              shape="round"
              size="small"
              icon="search"
              className="ml4"
              onClick={()=>{ window.open(organizationResponse.DeskUrl, '_blank') }}
            >
              Open Desk
            </Button>
          ],
        }
      ]
    }

    return []
  }

  getBillingList = () : Array<GridView> => {
    const { organizationResponse } = this.state;

    if (this.hasOrganization()) {

      const currentPlanName = this.getCurrentPlanName();

      return [
        {
          title: 'Plan:',
          description: [
            <span style={{ fontSize: '16px', lineHeight: '36px' }} key="title">
              {currentPlanName}
            </span>,
            <Button
              key="editPlanButton"
              type="primary"
              shape="round"
              size="small"
              icon="edit"
              className="ml4"
              disabled={!this.state.canChangePlan}
              onClick={() => this.handleOnOpenModal({ plans: this.state.plans }, MODAL_TYPES.EditAccountPlan)}>
              Change Plan
            </Button>
          ]
        },
        {
          title: 'Balance:',
          description: [
            <div key="balance-wrapper" className="flex items-baseline">
              <Statistic
                key="balance"
                value={organizationResponse.Balance}
                precision={2} />
              <Button
                key="credit"
                type="primary"
                shape="round"
                size="small"
                icon="swap"
                className="ml4"
                onClick={() => this.handleOnOpenModal({}, MODAL_TYPES.PerformTransaction)}>
                Add or remove Credits
              </Button>
            </div>
          ],
        }
      ]
    }

    return []
  }

  getAiAgentsList  = (): Array<GridView> => {
    const buttonText = this.state.aiAgentsPlanName === AI_AGENT_PLAN_NOT_DEFINED ? 'Define Plan' : 'Change Plan';

    if (this.hasOrganization()) {
      const { aiAgentsPlanName } = this.state;

      return [
        {
          title: 'Plan:',
          description: [
            <span style={{ fontSize: '16px', lineHeight: '36px' }} key="title">
              {aiAgentsPlanName}
            </span>,
            <Button
              key="editPlanButton"
              type="primary"
              shape="round"
              size="small"
              icon="edit"
              className="ml4"
              disabled={!this.state.canChangePlan}
              onClick={async () => {
                await this.getAllAiAgentsPlans();
                this.handleOnOpenModal({ plans: this.state.allAiAgentsPlans,  planName: this.state.aiAgentsPlanName }, MODAL_TYPES.SetAiAgentsPlan);
              }}
            >
              {buttonText}
            </Button>
          ]
        }
      ]
    }
    return []
  }

  render() {
    const { organizationResponse, isLoading } = this.state

    const itemList = this.getItemList()
    const billingItems = this.getBillingList()
    const aiAgentsItems = this.getAiAgentsList()

    const billingTab = () => (
      <div className="mt5 w-100">
        <Card title="Billing Information" className="mb3">
          <List
            grid={{ gutter: 16, column: 2 }}
            dataSource={billingItems}
            loading={isLoading}
            key="billing"
            renderItem={item => (
              <ListItem>
                <Card title={item.title}>
                  {item.description}
                </Card>
              </ListItem>
            )}>
          </List>
        </Card>
      </div>
    )

    const AiAgentsTab = () => (
      <div className="mt5 w-100">
        <Card title="Ai Agents Information" className="mb3">
          <List
            grid={{ gutter: 16, column: 2 }}
            dataSource={aiAgentsItems}
            loading={isLoading}
            key="aiagents"
            renderItem={item => (
              <ListItem>
                <Card title={item.title}>{item.description}</Card>
              </ListItem>
            )}
          />
        </Card>
      </div>
    )

    const subscriptionTab = () => (
      <div className="mt5 w-100">
        <Card title="Organization Information">
          <List
            loading={isLoading}
            itemLayout="horizontal"
            dataSource={itemList}
            renderItem={item => (
              <ListItem>
                <ListItemMeta
                  title={item.title}
                  description={item.description}>
                </ListItemMeta>
              </ListItem>
            )}>
          </List>
        </Card>
      </div>
    )

    return (
      <div className="flex flex-wrap">
        <div className="tc w-100">
          <h1><Icon type="bank" className="mr3" />Search Organization by id</h1>
          <Search
            placeholder="Organization id"
            enterButton="Search"
            loading={this.state.isLoadingButtonSearch}
            size="large"
            style={{ width: 400 }}
            onSearch={this.onSearch}
            allowClear
          />
        </div>
        {this.hasOrganization() && <Tabs defaultActiveKey="1" className="w-100" activeKey={this.state.activeTabKey} onChange={this.handleTabChange}>
          <TabPane tab="Overview" key="1">
            {subscriptionTab()}
          </TabPane>
          <TabPane tab="Billing" key="2">
            {billingTab()}
          </TabPane>
          <TabPane tab="Members" key="3">
            <OrganizationMembers {...organizationResponse}></OrganizationMembers>
          </TabPane>
          <TabPane tab="Applications" key="4">
            <OrganizationApplications {...organizationResponse}></OrganizationApplications>
          </TabPane>
          <TabPane tab="Ai Agents" key="5">
            {AiAgentsTab()}
          </TabPane>
          <TabPane tab="Marketing & AI Products" key="6">
            <AiAgentStudioComponent tenantId={organizationResponse.Id} loading={this.state.isLoading} />
          </TabPane>
          <TabPane tab="mTLS" key="7">
            <OrganizationMTLS {...organizationResponse}></OrganizationMTLS>
          </TabPane>
        </Tabs>
        }
        <ModalFactory
          wrappedComponentRef={this.saveFormRef}
          visible={this.state.isModalVisible}
          onCancel={() => this.handleModalVisibility(this.state.currentModal, false)}
          onOk={this.handleSaveTenantOwnerIdentity}
          loading={this.state.isModalLoading}
          type={this.state.currentModal}
          record={this.state.editingRecord}
          maskClosable={false}
        />
        <ModalFactory
          wrappedComponentRef={this.saveFormRef}
          visible={this.state.isModalVisible}
          onCancel={() => this.handleModalVisibility(this.state.currentModal, false)}
          onOk={() => this.handleOnOkModal(this.state.currentModal)}
          loading={this.state.isModalLoading}
          type={this.state.currentModal}
          record={this.state.editingRecord}
          maskClosable={false}
        />
      </div>
    )
  }
}
